import { createSlice } from '@reduxjs/toolkit';
import { ConfigState } from '../types/config.type';

export const CONFIG_DEFAULT_STATE: ConfigState = {
    apiContext: '/competitive',
    participationToken: 'EPIC_PARTICIPATION'
};

const configSlice = createSlice({
    name: 'config.info',
    initialState: CONFIG_DEFAULT_STATE,
    reducers: {}
});

export const configReducer = configSlice.reducer;
